// extracted by mini-css-extract-plugin
export default {"keyword":"index_keyword_6X5O4","keywordHead":"index_keywordHead_VPXG-","keywordText":"index_keywordText_bVR92"};